// ==============================================
// FILE: frontend/src/components/Navigation.js
// ==============================================

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield, LogOut, Settings } from 'lucide-react'; // Removed MessageSquare since we are using image
import { useAuth } from '../hooks/useAuth';
import { ROUTES } from '../config/api.config';
import logo from '../assests/images/logo1.png'; // Your import

const Navigation = () => {
  const location = useLocation();
  const { user, isAuthenticated, isSuperAdmin, logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.href = ROUTES.LOGIN;
  };

  // Don't show nav on login pages
  if (location.pathname === ROUTES.LOGIN || location.pathname === ROUTES.SUPER_ADMIN_LOGIN) {
    return null;
  }

  return (
    <nav className="fixed top-[80px] left-0 right-0 z-40 bg-white/90 backdrop-blur-xl border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          
          {/* ================================================= */}
          {/* 👇 LOGO SECTION UPDATED HERE 👇                   */}
          {/* ================================================= */}
          <Link to="/" className="flex items-center gap-3 font-bold text-xl text-gray-800 hover:text-cyan-600 transition-colors">
            {/* Displaying the imported logo image */}
            <img 
              src={logo} 
              alt="GLOCYBS Logo" 
              className="h-10 w-auto object-contain" 
            />
            <span>Feedback System</span>
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center gap-4">
            {!isAuthenticated ? (
              <>
                <Link 
                  to={ROUTES.LOGIN}
                  className="px-4 py-2 text-gray-700 hover:text-cyan-600 font-medium transition-colors"
                >
                  Admin Login
                </Link>
                <Link 
                  to={ROUTES.SUPER_ADMIN_LOGIN}
                  className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-xl font-bold transition-colors flex items-center gap-2"
                >
                  <Shield size={18} />
                  Super Admin
                </Link>
              </>
            ) : (
              <>
                {isSuperAdmin ? (
                  <>
                    <Link 
                      to={ROUTES.SUPER_ADMIN_APPROVALS}
                      className={`px-4 py-2 font-medium transition-colors flex items-center gap-2 ${
                        location.pathname === ROUTES.SUPER_ADMIN_APPROVALS
                          ? 'text-purple-600'
                          : 'text-gray-700 hover:text-purple-600'
                      }`}
                    >
                      <Settings size={18} />
                      Approvals
                    </Link>
                    <Link 
                      to={ROUTES.ADMIN_DASHBOARD}
                      className={`px-4 py-2 font-medium transition-colors ${
                        location.pathname === ROUTES.ADMIN_DASHBOARD
                          ? 'text-purple-600'
                          : 'text-gray-700 hover:text-purple-600'
                      }`}
                    >
                      Dashboard
                    </Link>
                  </>
                ) : (
                  <Link 
                    to={ROUTES.ADMIN_DASHBOARD}
                    className={`px-4 py-2 font-medium transition-colors ${
                      location.pathname === ROUTES.ADMIN_DASHBOARD
                        ? 'text-cyan-600'
                        : 'text-gray-700 hover:text-cyan-600'
                    }`}
                  >
                    Dashboard
                  </Link>
                )}
                
                <div className="flex items-center gap-3 pl-4 border-l border-gray-300">
                  <div className="text-sm">
                    <p className="font-medium text-gray-700">{user?.full_name}</p>
                    <p className="text-xs text-gray-500 capitalize">{user?.role?.replace('_', ' ')}</p>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    title="Logout"
                  >
                    <LogOut size={20} />
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;